


























































import { Component, Prop, Vue } from 'vue-property-decorator'
import { userType } from '@/app/model/store/domain/const'
@Component
export default class AccountList extends Vue {
  private userType: string = ''
  private displayRemarksData: string = ''

  @Prop() private data!: any

  created () {
    this.displayRemarks()
  }

  private displayUserType (type: number) {
    if (type === userType.USER_TYPE_FARM_WORKER) {
      return '圃場作業者'
    } else if (type === userType.USER_TYPE_FARM_ADMIN) {
      return '圃場管理者'
    } else if (type === userType.USER_TYPE_ADMIN) {
      return '経営者'
    }
  }

  private displayRemarks () {
    if (this.data.remarks.length > 30) {
      this.displayRemarksData = this.data.remarks.substr(0, 20) + '…'
    } else {
      this.displayRemarksData = this.data.remarks
    }
  }
}

